import { render, staticRenderFns } from "./BlackVisitor.vue?vue&type=template&id=9112b172&scoped=true&"
import script from "./BlackVisitor.vue?vue&type=script&lang=js&"
export * from "./BlackVisitor.vue?vue&type=script&lang=js&"
import style0 from "./BlackVisitor.vue?vue&type=style&index=0&id=9112b172&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9112b172",
  null
  
)

export default component.exports